export const normalizeDate = (value: string) => String(value).slice(0, 10)

export const normalizeTime = (value: string) => String(value).slice(0, 5)

export const isoDate = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

// Parses 'YYYY-MM-DD' as a local date (avoids the UTC shift of new Date(str))
export const parseISODate = (value: string): Date => {
  const [y, m, d] = value.split('-').map(Number)
  return new Date(y, m - 1, d)
}

// Monday of the week containing `d`
export const startOfWeek = (d: Date): Date => {
  const day = (d.getDay() + 6) % 7 // Monday = 0
  const monday = new Date(d)
  monday.setDate(d.getDate() - day)
  return monday
}

export const addDays = (d: Date, days: number): Date => {
  const next = new Date(d)
  next.setDate(d.getDate() + days)
  return next
}
